module.exports = __webpack_public_path__ + "img/warning.c15078ba.svg";